function deepFreeze(value) {
  if (value && typeof value === "object" && !Object.isFrozen(value)) {
    Object.values(value).forEach(deepFreeze);

    Object.freeze(value);
  }

  return value;
}

export const MAIN_NAV_ITEMS = deepFreeze([
  { id: "about-me", label: "About me" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "contact", label: "Contact" },
]);

export const WORLD_SECTIONS = deepFreeze({
  studio: {
    label: "About me",
    creativeTitle: "Prem's Studio",
    action: "Explore About me",
    description: "Meet Prem and understand the kind of software work he does.",
  },

  agent: {
    label: "AI marketplace",
    creativeTitle: "Agent Workshop",
    action: "Explore AI marketplace",
    description:
      "Discover creator-published agents for supported tools and workflows.",
  },

  tower: {
    label: "Orchestrator",
    creativeTitle: "Orchestration Tower",
    action: "Explore Task automation",
    description:
      "How multi-step work is coordinated, saved, checked, and resumed.",
  },

  products: {
    label: "Products & workflows",
    creativeTitle: "Product District",
    action: "Explore Web & mobile apps",
    description:
      "ReelChain, ContentStudio and BillFlow: video creation, content automation and billing.",
  },

  incident: {
    label: "Problem-solving",
    creativeTitle: "Case Studies",
    action: "Explore Problem-solving",
    description:
      "Three examples from my work: faster responses, reusable frontend code and AI-assisted fixes with human review.",
  },

  contact: {
    label: "Contact",
    creativeTitle: "Rooftop",
    action: "Explore Contact",
    description:
      "Résumé, professional links, location, and the next step for speaking with Prem.",
  },
});

export function getWorldSection(zoneId) {
  return WORLD_SECTIONS[zoneId] ?? WORLD_SECTIONS.studio;
}
